const baseTheme = require("./base-theme");

module.exports = {
    ...baseTheme,
    colors: {
        ...baseTheme.colors,
        primary: "#4cce5f",
    },
};
